module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-panel",
    class: {
      open: _vm.panelOpen
    },
    on: {
      "click": function($event) {
        _vm.panelDown($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.panelOpen),
      expression: "panelOpen"
    }],
    attrs: {
      "type": "checkbox",
      "id": "panel-toggle",
      "name": "panel-toggle"
    },
    domProps: {
      "checked": Array.isArray(_vm.panelOpen) ? _vm._i(_vm.panelOpen, null) > -1 : (_vm.panelOpen)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.panelOpen,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.panelOpen = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.panelOpen = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.panelOpen = $$c
        }
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel-container"
  }, [_c('transition', {
    attrs: {
      "name": "sbfade",
      "mode": "out-in",
      "appear": ""
    }
  }, [(_vm.activePanel) ? _c(_vm.activePanel.panel, {
    tag: "component",
    attrs: {
      "slug": _vm.activePanel.slug,
      "service": _vm.activePanel.service,
      "premise": _vm.activePanel.premise
    }
  }) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6ded4014","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarPanel.vue
// module id = 463
// module chunks = 1